import axios from 'axios';
const API = process.env.REACT_APP_BACKEND_URL + '/api';
const KEY = 'xenicos.push.binding';
export const currentBinding = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } };
export const rememberBinding = value => localStorage.setItem(KEY, JSON.stringify(value));
export const sendToWorker = async data => {
  const registration = await navigator.serviceWorker.getRegistration('/');
  if (!registration?.active) {
    if (data.type === 'BIND_PUSH') throw new Error('La aplicación aún no está preparada para recibir avisos.');
    return;
  }
  if (data.type === 'BIND_PUSH' && currentBinding()?.binding !== data.binding) throw new Error('La sesión ha cambiado.');
  await new Promise((resolve, reject) => {
    const channel = new MessageChannel();
    const timer = setTimeout(() => { channel.port1.close(); if (data.type === 'BIND_PUSH') reject(new Error('No se pudo preparar la recepción de avisos.')); else resolve(); }, 2500);
    channel.port1.onmessage = () => { clearTimeout(timer); channel.port1.close(); resolve(); };
    registration.active.postMessage(data, [channel.port2]);
  });
};
export async function clearDevicePush() {
  const saved = currentBinding();
  localStorage.removeItem(KEY);
  if ('serviceWorker' in navigator) {
    await sendToWorker({ type: 'CLEAR_PUSH', closeNotifications: 'Notification' in window && Notification.permission === 'granted' });
    // Un permiso denegado ya impide la recepción y algunos navegadores no ofrecen
    // un servicio push nativo en ese estado. Revocar siempre también en servidor.
    if ('Notification' in window && Notification.permission === 'granted') {
      const registration = await navigator.serviceWorker.getRegistration('/');
      const subscription = await registration?.pushManager?.getSubscription();
      await subscription?.unsubscribe().catch(() => {});
    }
  }
  if (saved?.binding) {
    await axios.delete(`${API}/push/subscription/${encodeURIComponent(saved.binding)}`, { withCredentials: true, timeout: 5000 }).catch(() => {});
  }
}
export async function syncPushBadge() {
  const saved = currentBinding();
  if (!saved) return;
  const { data } = await axios.get(`${API}/push/badge`, { withCredentials: true });
  await sendToWorker({ type: 'PUSH_BADGE', binding: saved.binding, count: data.count, countAt: data.count_at });
}
export function decodePublicKey(value) {
  const text = value.replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(text + '='.repeat((4 - text.length % 4) % 4)), character => character.charCodeAt(0));
}